import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { Item } from 'devextreme-react/tab-panel';
import('@apply/components/src/scss/controls/_togglebutton.scss');

interface CCLTabParameters {
    isCCL_Borrower: boolean;
    set_isCCL_Borrower: React.Dispatch<React.SetStateAction<boolean>>;
    requireTermsheet: boolean;
    set_requireTermsheet: React.Dispatch<React.SetStateAction<boolean>>;
    requireUnderwritingFee: boolean;
    set_requireUnderwritingFee: React.Dispatch<React.SetStateAction<boolean>>;
    requireValuationFee: boolean;
    set_requireValuationFee: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CCLTab: React.FC<CCLTabParameters> = ({
    isCCL_Borrower,
    set_isCCL_Borrower,
    requireTermsheet,
    set_requireTermsheet,
    requireUnderwritingFee,
    set_requireUnderwritingFee,
    requireValuationFee,
    set_requireValuationFee,
}) => {
    return (
        <Item title='CCL'>
            <div
                style={{
                    width: '100%',
                    minHeight: '700px',
                    marginTop: 20,
                }}
            >
                <div style={{ padding: '20px 50px' }}>
                    <YesNoToggleButton
                        id='moreThan10kExpenditures'
                        value={isCCL_Borrower}
                        onItemClick={(e: ButtonGroupTypes.ItemClickEvent) => set_isCCL_Borrower(e.itemData?.id === 'Yes')}
                        width='230px'
                        height='40px'
                        label={'Is this a CCL Borrower for construction and fix-flip?'}
                        labelSize={ToggleButtonLabelSize.Large}
                    />
                </div>
                {isCCL_Borrower && (
                    <>
                        <div style={{ padding: '20px 50px' }}>
                            <YesNoToggleButton
                                id='moreThan10kExpenditures'
                                value={requireTermsheet}
                                onItemClick={(e: ButtonGroupTypes.ItemClickEvent) =>
                                    set_requireTermsheet(e.itemData?.id === 'Yes')
                                }
                                width='230px'
                                height='40px'
                                label={'Require termsheet?'}
                                labelSize={ToggleButtonLabelSize.Large}
                            />
                        </div>
                        <div style={{ padding: '20px 50px' }}>
                            <YesNoToggleButton
                                id='moreThan10kExpenditures'
                                value={requireUnderwritingFee}
                                onItemClick={(e: ButtonGroupTypes.ItemClickEvent) =>
                                    set_requireUnderwritingFee(e.itemData?.id === 'Yes')
                                }
                                width='230px'
                                height='40px'
                                label={'Require underwriting fee?'}
                                labelSize={ToggleButtonLabelSize.Large}
                            />
                        </div>
                        <div style={{ padding: '20px 50px' }}>
                            <YesNoToggleButton
                                id='moreThan10kExpenditures'
                                value={requireValuationFee}
                                onItemClick={(e: ButtonGroupTypes.ItemClickEvent) =>
                                    set_requireValuationFee(e.itemData?.id === 'Yes')
                                }
                                width='230px'
                                height='40px'
                                label={'Require valuation fee?'}
                                labelSize={ToggleButtonLabelSize.Large}
                            />
                        </div>
                    </>
                )}
            </div>
        </Item>
    );
};
